'use client';

import Image from 'next/image';
import { Button } from '@/components/ui/button';
import Link from 'next/link';

export default function GlobalError({ error: _error, reset }) {
  return (
    <html>
      <body>
        <div className="flex flex-col items-center justify-center min-h-screen bg-background p-4 relative">
          {/* Illustration in the center */}
          <Image
        src="/images/careeroffensive-error-1-min.png"
        alt="Error Illustration"
            width={200}
            height={200}
            className="mb-6 h-auto"
            priority
          />

          {/* Error Message */}
          <div className="text-center">
            <h1 className="text-2xl font-semibold text-foreground mb-4">
              We're sorry, something went wrong.
            </h1>
            <p className="text-muted-foreground mb-6">
              We're experiencing a technical issue. Our team has been notified and is working to fix it.
            </p>

            {/* Buttons */}
            <div className="flex justify-center space-x-4 mt-4">
              <Button onClick={() => reset()} className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90">
                Try Again
              </Button>
              <Link href="/">
                <Button variant="outline" className="px-4 py-2 border border-border rounded-md hover:bg-muted">
                  Go Home
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
} 
